import { render, staticRenderFns } from "./DashboardNotifications.vue?vue&type=template&id=cae81488&scoped=true"
import script from "./DashboardNotifications.vue?vue&type=script&lang=js"
export * from "./DashboardNotifications.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotifications.vue?vue&type=style&index=0&id=cae81488&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae81488",
  null
  
)

export default component.exports